import React, { useState } from 'react';
import { useTheme } from '../../context/shared/ThemeContext'

interface HelpTooltipProps {
  content: string;
  title?: string;
  children?: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  size?: 'sm' | 'md' | 'lg';
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ 
  content, 
  title, 
  children, 
  position = 'top',
  size = 'md'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { themeClasses } = useTheme();

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  const sizeClasses = {
    sm: 'max-w-xs',
    md: 'max-w-sm',
    lg: 'max-w-md'
  };

  const arrowClasses = {
    top: 'top-full left-1/2 transform -translate-x-1/2 border-t-gray-800',
    bottom: 'bottom-full left-1/2 transform -translate-x-1/2 border-b-gray-800',
    left: 'left-full top-1/2 transform -translate-y-1/2 border-l-gray-800',
    right: 'right-full top-1/2 transform -translate-y-1/2 border-r-gray-800'
  };

  return (
    <div className="relative inline-block">
      <div
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-200 text-gray-600 text-xs font-medium cursor-help hover:bg-gray-300 transition-colors"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        tabIndex={0}
        role="button"
        aria-label="Help"
      >
        ?
      </div>
      
      {isVisible && (
        <div className={`absolute z-50 ${positionClasses[position]} ${sizeClasses[size]}`}>
          <div className={`${themeClasses.cardBg} ${themeClasses.border} rounded-lg shadow-lg p-3 text-sm`}>
            {title && (
              <h4 className={`font-semibold mb-1 ${themeClasses.primaryText}`}>
                {title}
              </h4>
            )}
            <p className={`${themeClasses.secondaryText}`}>
              {content}
            </p>
            <div className={`absolute w-0 h-0 border-4 border-transparent ${arrowClasses[position]}`} />
          </div>
        </div>
      )}
      
      {children}
    </div>
  );
};

export default HelpTooltip; 